import { lazy, Suspense, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Loading from '../../../components/comComponents/Loading';
import AccordionItem from '../../../components/doc/scrap/AccordionItem';
import ScrapList from '../../../components/doc/scrap/ScrapList';
import Header from '../../../components/header/Header';
import { chkBizType, chkOsType, loginDomain, osDetail, osType } from '../../../modules/Common';
import { ErrorModule } from '../../../modules/ErrorModule';
import { callOpenApiNonAuth } from '../../../modules/TokenBase';

const Index = () =>{
    const navigate = useHistory();
    const [active, setActive] = useState(null);
    const [scrapList, setScrapList] = useState(''); //스크래핑 목록
    const [docBank, setDocBank] = useState('');//서류제출 영업점
    const [btnOn, setBtnOn] = useState(true); //버튼 활성화 여부
    const [alertContents, setAlertContents] = useState(''); //알림 내용
    const [alertIcon, setAlertIcon] = useState(''); //알림 아이콘
    const [alertOpen, setAlertOpen] = useState(false); //알림 오픈 여부
    const [goMain, setGoMain] = useState(false);// 알림 팝업 닫은 후 추가 액션을 취하고 싶을때 추가
    const [goCertCenter, setGoCertCenter] = useState(false); // 알림 팝업 닫은 후 추가 액션을 취하고 싶을때 추가
    const [loadOpen, setLoadOpen] = useState(false); //로딩 여부
    
    const OneBtnAlert = lazy(()=> import('../../../components/comComponents/OneBtnAlert'));

    //서류제출 영업점 조회
    const selBank = () =>{
        setLoadOpen(true);
        const param = {
            "bzn" : sessionStorage.getItem('docBizNo')
        }
        callOpenApiNonAuth("/api/cm/v1/cms010/docSbmsBobInq", param, function( result ){
            setLoadOpen(false);
            if(result.STATUS == "0000"){
                let data = result.RSLT_DATA;
                let tempBank = data.mngmBrm+"("+data.mngmAdr+")";
                setDocBank(tempBank);
            }else{
                setAlertIcon("F");
                setAlertContents(result.RSLT_MSG)
                alertFun(true);
            }
        },function (e) {
            setLoadOpen(false);
            let param = ErrorModule(e);
            if(param) {
                setAlertIcon("F");
                setAlertContents("["+e.responseJSON.msgCd+"]"+e.responseJSON.mnmsgCntn);
                alertFun(true);
            }
        });
    }

    //클라우드 인증서 등록여부 체크
    const chkCloudCert = () =>{
        if(btnOn){
            setLoadOpen(true);
            const param = {
                "bzn" : sessionStorage.getItem('docBizNo')
            }
            callOpenApiNonAuth("/api/cm/v1/cms010/atshInfoInq", param, function( result ){
                if(result.STATUS == "0000"){
                    var data = result.RSLT_DATA;
                    if(data.atshRgsnYn == "N"){ //클라우드 인증서 등록 여부 체크(N)
                        setLoadOpen(false);
                        if(osType() === "mobile"){ // [CM5000-04] 공동인증서 등록 안내 화면으로 이동
                            navigate.push('/doc/cert');
                        }else{
                            window.location.href = loginDomain()+"/ACC001/doc.do?bizno="+sessionStorage.getItem('docBizNo')+"&biznm="+btoa(encodeURIComponent(sessionStorage.getItem('docBizNm')))
                        }
                    }else{//클라우드 인증서 등록 여부 체크(Y)
                        startScraping()
                    }
                }else{
                    setLoadOpen(false);
                    setAlertIcon("F");
                    setAlertContents(result.RSLT_MSG)
                    alertFun(true);
                }
            },function (e) {
                setLoadOpen(false);
                let param = ErrorModule(e);
                if(param) {
                    setAlertIcon("F");
                    setAlertContents("["+e.responseJSON.msgCd+"]"+e.responseJSON.mnmsgCntn);
                    alertFun(true);
                }
            });
        }
        
    }

    const startScraping = () =>{
        const param = {
            "bzn" : sessionStorage.getItem('docBizNo'),
            "userChnlNm": btoa(encodeURIComponent(chkOsType())),
            "userTrunCon": btoa(encodeURIComponent(osDetail()))
        }
        callOpenApiNonAuth("/api/cm/v1/cms010/docSbmsRqstCrt", param, function( result ){
            setLoadOpen(false);
            if(result.STATUS == "0000"){
                var data = result.RSLT_DATA;
                if(data.docSbmsId){
                    navigate.push('/doc/completion');
                }else{
                    setAlertIcon("F");
                    setAlertContents(result.RSLT_MSG)
                    alertFun(true);
                }
            }else if(result.STATUS == "9998"){
                setGoCertCenter(true);
                setAlertIcon("F");
                setAlertContents(result.RSLT_MSG)
                alertFun(true);
            }else{
                setAlertIcon("F");
                setAlertContents(result.RSLT_MSG)
                alertFun(true);
            }
        },function (e) {
            setLoadOpen(false);
            let param = ErrorModule(e);
            if(param) {
                setAlertIcon("F");
                setAlertContents("["+e.responseJSON.msgCd+"]"+e.responseJSON.mnmsgCntn);
                alertFun(true);
            }
        });
        
    }

    const chkBtn = (onBtn) =>{
        setBtnOn(onBtn); //현재(24.03.15) 대출꾸러미가 하나여서 한개의 체크박스 체크 여부만 체크
    };

    //알림 오픈 함수
    const alertFun = (open) => {
        setAlertOpen(open);

        //아래 코드는 알림팝업 닫은 후 실행할 추가 액션 코드(메인화면으로 이동)
        if(!open){
            if(goMain){
                sessionStorage.clear();
                navigate.push('/');
            }

            if(goCertCenter){
                if(osType() === "mobile"){ // [CM5000-04] 공동인증서 등록 안내 화면으로 이동
                    navigate.push('/doc/cert');
                }else{
                    window.location.href = loginDomain()+"/ACC001/doc.do?bizno="+sessionStorage.getItem('docBizNo')+"&biznm="+btoa(encodeURIComponent(sessionStorage.getItem('docBizNm')))
                }
                setGoCertCenter(false);
            }
        }
    }


    useEffect(()=>{
        if(sessionStorage.getItem('docBizNo')){
            if(chkBizType(sessionStorage.getItem('docBizNo')) === "corporate"){
                setScrapList(ScrapList('corpList'));
            }else{
                setScrapList(ScrapList('indiList'));
            }

            //서류제출 영업점 조회
            selBank();
            
        }else{
            setGoMain(true);
            setAlertIcon("F");
            setAlertContents("부정한접근입니다.")
            alertFun(true);
        }
        
    },[])
    return(
        <div>
            <Header headerTitle="서류제출" arrowYn={true} closeYn={false}/> 
            <div id="container">		
                <div className="content">
                    <div className="wrapBoxPd bottomGnbShow">
                        <div className="formbox">
                            <p className="tit">서류제출 영업점</p>
                            <div className="valChk">
                                <div className="inpbox">
                                    <input type="text" className="txtBold" placeholder={docBank} readOnly/>
                                </div>
                                <span className="infoTxt"></span>
                            </div>
                        </div>

                        <div className="accordionWrap mt24">
                            <div className="accordionList">
                                {scrapList&&scrapList.map((item, index) => {
                                        return (
                                            <AccordionItem key={index} active={active} termText={item} chkBtn={chkBtn} /*hadleToggle={handleToggle}*/ />
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="fullbtn">
                    <a className={`btn ${btnOn ? 'on':''}`} onClick={()=>{chkCloudCert()}}>확인</a>
                </div>
            </div>
            <Suspense fallback={<></>}>
                {alertOpen ? <OneBtnAlert alertContents={alertContents} alertOpen={alertOpen} alertFun={alertFun} alertIcon={alertIcon}/> : <></>}
            </Suspense>
            <Loading loadOpen={loadOpen}/>
        </div>
    );
}
export default Index;